import React, { useState } from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';
import './ProductModal.css';

const DeleteTipoCajaModal = ({ tipoCaja, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    try {
      await onDelete(tipoCaja.id);
      onClose();
    } catch (err) {
      console.error('Error deleting tipo de caja:', err);
      const errorMessage = err.message || 'Error al eliminar el tipo de caja';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const isConfirmed = confirmText.toLowerCase() === 'eliminar';

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content delete-modal">
        {/* Header */}
        <div className="modal-header delete-header">
          <div>
            <h2 className="modal-title">
              <AlertTriangle size={24} className="inline-icon" />
              Eliminar Tipo de Caja Permanentemente
            </h2>
            <p className="modal-subtitle">Esta acción eliminará el registro de la base de datos</p>
          </div>
          <button 
            className="btn-icon" 
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="delete-warning">
            <div className="warning-icon">
              <AlertTriangle size={48} />
            </div>
            <p className="warning-text">
              ¿Está seguro que desea eliminar permanentemente este tipo de caja?
            </p>
            {error && (
              <div className="error-message" style={{
                backgroundColor: '#fee2e2',
                border: '1px solid #fca5a5',
                borderRadius: '8px',
                padding: '0.75rem',
                marginBottom: '1rem',
                color: '#991b1b',
                fontSize: '0.875rem'
              }}>
                <strong>Error:</strong> {error}
              </div>
            )}
            <div className="product-details">
              <div className="detail-row">
                <span className="detail-label">Tipo:</span>
                <span className="detail-value">{tipoCaja.tipo}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Descripción:</span>
                <span className="detail-value">{tipoCaja.descripcion}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Estado:</span>
                <span className="detail-value">
                  {tipoCaja.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>
            </div>
            <div className="confirmation-section">
              <p className="confirmation-instruction">
                Para confirmar, escriba <strong>ELIMINAR</strong> en el campo de abajo:
              </p>
              <input
                type="text"
                className="form-input confirmation-input"
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                placeholder="Escriba ELIMINAR"
                autoFocus
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={loading || !isConfirmed}
          >
            <Trash2 size={18} />
            {loading ? 'Eliminando...' : 'Eliminar Tipo de Caja'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTipoCajaModal;
